<script>
import moment from "moment";
import PagenationContainer from "@/components/common/PagenationContainer.vue";
export default {
  components: {
    PagenationContainer
  },
  data() {
    let showEdit =
      localStorage.getItem("roles").indexOf("ROLE_GROUP_OPTOMETRIST") > -1;
    return {
      tableData: [],
      pageCount: 0,
      activePage: 1,
      tabList: [
        {
          label: "精细刺激训练",
          key: "FINE_STIMULATION_TRAINING"
        },
        {
          label: "视觉技巧训练",
          key: "VISUAL_SKILL_TRAINING"
        },
        {
          label: "同时视",
          key: "SAME_TIME_BINOCULAR_VISION_TRAINING"
        },
        {
          label: "融合视",
          key: "FUSION_VISION_BINOCULAR_VISION_TRAINING"
        },
        {
          label: "立体视",
          key: "STEREOSCOPIC_BINOCULAR_VISION_TRAINING"
        },
        {
          label: "Gabor训练",
          key: "GABOR_TRAINING"
        },
        {
          label: "对比敏感度训练",
          key: "CONTRAST_SENSITIVITY_TRAINING"
        },
        {
          label: "信息提取训练",
          key: "INFORMATION_EXTRACTION_TRAINING"
        }
      ],
      activeTab: "FINE_STIMULATION_TRAINING",
      gameLists: [],
      showEdit
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      let data = await this.$http.getGameList(this.activeTab);
      this.gameLists = data.data.content;
    },
    async switchTab(tabKey) {
      this.activeTab = tabKey;
      this.loadData();
    },
    async saveEditResult(data) {
      console.log(">>>>>>>", data);
      const result = await this.$http.putGameIntroduce(data);
      if (result) {
        this.$message.success("更改成功！");
        this.loadData();
      }
    }
  }
};
</script>
<template>
  <div class="gameIntroduce">
    <gameIntroduceTabs :tabList="tabList" @switchTab="switchTab">
      <el-row :gutter="24">
        <el-col :span="24" v-for="(game) in gameLists" :key="game.id">
          <gameIntroduceCard :item="game" @saveEditResult="saveEditResult" :showEdit="showEdit" />
        </el-col>
      </el-row>
    </gameIntroduceTabs>
  </div>
</template>

<style lang="scss" scoped>
@import "@/css/color.scss";

.gameIntroduce {
  .rightBorder {
    border-right: 1px solid #e8e8e8;
  }

  .el-row {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }

  .el-col {
    padding-top: 10px;
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/gameIntroduce/index.vue